import React from "react"
import clsx from "clsx"
import CircularProgress from "@material-ui/core/CircularProgress"

import useESIA from "../../../ESIA/useESIA"
import { PlacementsESIA } from "../../../ESIA/types"

import * as styles from "./esiaBtn.module.scss"
import { EsiaFlag } from "./icons/EsiaFlag"

type EsiaBtnProps = {
  productName?: string
  placement?: PlacementsESIA
}

export function EsiaBtn({ productName = "КК Халва", placement = "main" }: EsiaBtnProps) {
  const { requestStatus, handleESIAClick, isButtonDisabled } = useESIA(productName)

  const handleClick = () => {
    if (!isButtonDisabled) {
      handleESIAClick(placement)
    }
  }

  const buttonContent =
    requestStatus === "loading" ? (
      <CircularProgress color="inherit" size={20} />
    ) : (
      <>
        <EsiaFlag />
        <>Заполнить через Госуслуги</>
      </>
    )

  return (
    <button
      className={clsx(styles.esiaBtn, { [styles.loading]: requestStatus === "loading" })}
      onClick={handleClick}
      type="button"
    >
      {buttonContent}
    </button>
  )
}
